import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { QueryKeys } from '../constants';
import { API_BASE_URL, useFetch } from './utils';

// not using useFetch here becauase we do not need authentication
export const useValidateInvitation = () => {
  return useMutation({
    mutationFn: async ({ token }) => {
      const response = await fetch(`${API_BASE_URL}api/v1/invitations/validate/`, {
        method: 'POST',
        body: JSON.stringify({ token }),
      });
      if (!response.ok) {
        throw new Error('Something went wrong');
      }
      return response.json();
    },
  });
};

export const useInvitations = (options = {}) => {
  const fetcher = useFetch();
  return useQuery({
    queryKey: [QueryKeys.INVITATIONS],
    queryFn: () => fetcher({ path: 'v1/invitations/' }),
    ...options,
  });
};

export const useCreateInvitation = () => {
  const fetcher = useFetch();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ data }) =>
      fetcher({
        path: 'v1/invitations/create/',
        method: 'POST',
        data: JSON.stringify(data),
      }),
    onSettled: (_data, _error, { surveyId }) => {
      queryClient.invalidateQueries([QueryKeys.INVITATIONS]);
      if (surveyId) {
        queryClient.invalidateQueries([QueryKeys.SURVEY_INVITATIONS], { surveyId });
      }
    },
    onError: () => {
      message.error('Something went wrong inviting user');
    },
  });
};

export const useDeleteInvitation = () => {
  const fetcher = useFetch();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ invitationId }) =>
      fetcher({
        path: `v1/invitations/${invitationId}/delete/`,
        method: 'DELETE',
      }),
    onSettled: (_data, _error, { surveyId }) => {
      queryClient.invalidateQueries([QueryKeys.INVITATIONS]);
      if (surveyId) {
        queryClient.invalidateQueries([QueryKeys.SURVEY_INVITATIONS], { surveyId });
      }
    },
    onError: () => {
      message.error('Something went wrong deleting invitation');
    },
  });
};
